import { BaseSizeEnum as e } from "./common.js";
const p = {
  [e.Large]: "18px",
  [e.Medium]: "16px",
  [e.Small]: "14px"
};
export {
  p as OPTION_LIST_ICON_SIZE
};
//# sourceMappingURL=option-list.js.map
